<script lang="typescript">
  import { useMachine } from '@xstate/svelte';
  import type { MeetingType } from '../common/types';
  import { createAdminTypesMachine } from './machine';
  import EditType from './EditType.svelte';
  import NewType from './NewType.svelte';
  export let types:Array<MeetingType>;
  const machine = createAdminTypesMachine(types);
  const { state, send } = useMachine(machine);
  const reload = () => send('RELOAD');
  $: newMachine = $state.context.newMachine;
  $: typesFromContext = $state.context.types;
  $: isError = $state.matches('error');
  $: error = $state.context.error;
</script>
<main>

  {#if isError}
    <div class="panel panel-error">
      <p>Virhe tyyppien haussa</p>
      {@html error}
      <p>
      <button on:click={reload}>Yritä uudelleen</button>
      </p>
    </div>
  {/if}

  {#if newMachine }
    <h1>Lisää tapaamisen tyyppi</h1>
    <NewType machine={newMachine} />
  {/if}

  <h1>Muokkaa nykyisiä tyyppejä</h1>

  {#each typesFromContext as type (type.term_id)}
    <h2>{type.name}</h2>
    <EditType {type}/>
  {/each}

</main>
